import Endpoints from "../../constants/endpoints.js";
import httpService from "../httpService.js";

/*
 *Axios handles the creation of headers for us
 */
const upload = async (file) => {
  const url = Endpoints.fileStorage.upload;
  const formData = new FormData();

  formData.append(
    "file",
    file,
    file.name
  );

  const response = await httpService.post(url, formData, {
  }).catch(error => {
    if (error.response && error.response.status === 400) {
      console.log("msg: ", error.message);
    }
  });

  return response;
};

const getFile = async (id, fileType) => {
  const url = process.env.REACT_APP_BACKEND_URL + "/" + Endpoints.fileStorage.getFile.replace("{id}", id);
  // Fetch the original image
  return await fetch(url)
    // Retrieve its body as ReadableStream
    .then((response) => {
      const reader = response.body.getReader();
      return new ReadableStream({
        start(controller) {
          return pump();
          function pump() {
            return reader.read().then(({ done, value }) => {
              // When no more data needs to be consumed, close the stream
              if (done) {
                controller.close();
                return;
              }
              // Enqueue the next data chunk into our target stream
              controller.enqueue(value);
              return pump();
            });
          }
        },
      });
    })
    // Create a new response out of the stream
    .then((stream) => new Response(stream))
    // Create an object URL for the response
    .then((response) => response.blob())
    .then((blob) => {
      console.log(blob);
      return {data: blob, ok: true};})
    // Update image
    .catch((err) => console.error(err));
};

const getFileMetadata = async (id) => {
  const url = Endpoints.fileStorage.getFileMetadata.replace("{id}", id);
  const response = await httpService.get(url);
  return response;
}

const fileStorageService = {
  upload,
  getFile,
  getFileMetadata,
};

export default fileStorageService;
